import React, {Component} from 'react';
import util from 'Utils/commonUtil';
// Components
import {Card, Grid, Checkbox} from '@material-ui/core';
import Counter from 'Components/counter/Counter';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import ChangeShipmentImage from 'Components/commonOrder/ChangeShipmentImage';
import ChangeSwitch from 'Components/common/ChangeSwitch';

// Actions
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';

class ChangeShipmentCard extends Component {
    state = {
        dialogOpened: false,
        customerInfoOpened: false,
        isQuoteInfor: false,
        quoteDetailsOpened: false,
        num: 0,
        checked: true,
        changeSkuList: [],
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.defaultCheck !== this.props.defaultCheck) {
            this.setState({
                checked: nextProps.defaultCheck,
            });
        }
        if (nextProps.isQuoteInfor !== this.props.isQuoteInfor) {
            this.setState({
                isQuoteInfor: nextProps.isQuoteInfor,
            });
        }
        if (nextProps.reselectAllProductCheck) {
            this.setState({
                checked: nextProps.reselectAllProductCheck,
            });
        }
    }

    openDetails = (sku) => {
        this.setState({
            dialogOpened: true,
        });

        this.props.operation(sku);
    };

    closeDetails = () => {
        if (this.state.dialogOpened) {
            this.setState({
                dialogOpened: false,
            });
        }
    };

    openCustomerInfo = () => {
        this.setState({
            customerInfoOpened: true,
        });
    };

    closeCustomerInfo = () => {
        if (this.state.customerInfoOpened) {
            this.setState({
                customerInfoOpened: false,
            });
        }
    };

    openQuoteDetails = (param) => {
        if (this.props.getQuote) {
            this.props.getQuote(param);
        }
        this.setState({
            quoteDetailsOpened: true,
        });
    };

    closeQuoteDetails = () => {
        if (this.props.closeQuoteDetails) {
            this.props.closeQuoteDetails();
        }
        if (this.state.quoteDetailsOpened) {
            this.setState({
                quoteDetailsOpened: false,
            });
        }
    };

    copyContent = (text) => {
        this.closeQuoteDetails();

        if (this.props.copyContent) {
            this.props.copyContent(text);
        }
    };

    changeNum = (value) => {
        this.setState({
            num: value,
        });
        if (this.props.changeNum) {
            this.props.changeNum(this.props.cartInfo, value);
        }
    };

    handleCheck = (name) => (event) => {
        this.setState({[name]: event.target.checked});
        if (this.props.handleCheck) {
            this.props.handleCheck(
                event.target.checked,
                this.state.num || this.props.cartInfo.quantity,
                this.props.cartInfo,
            );
        }
    };

    comparePrice = (listPrice, efPrice) => {
        let flg = true;

        if (
            (efPrice &&
                listPrice &&
                parseFloat(efPrice) > parseFloat(listPrice)) ||
            !efPrice
        ) {
            flg = false;
        }

        return flg;
    };

    addShoppingCart = (productInfo, num) => (event) => {
        if (this.props.addShoppingCart) {
            this.props.addShoppingCart(productInfo, num, event);
        }
    };

    //value 为true表示官网, false表示现货中
    handleChange = (title, value, changeSku) => {
        let inventory = 0;
        if (!value) {
            inventory = this.props.productInfo.inventory;
        } else {
            if (this.props.productInfo.tfsInventory) {
                inventory = this.props.productInfo.tfsInventory;
            } else {
                if (this.props.productInfo.tfsInventory === 0) {
                    inventory = this.props.productInfo.tfsInventory;
                } else {
                    inventory = undefined;
                }
            }
        }
        this.props.collectChangeShipmentSku(
            inventory,
            value,
            changeSku,
            this.props.cartInfo.id,
        );
    };

    showDiscountPriceFun = () => {
        let {codeList} = this.props;
        let isDiscountPrice = false;
        codeList &&
            codeList.length > 0 &&
            codeList.forEach((codeItem) => {
                if (
                    codeItem.trim().substring(0, 1).toUpperCase() === 'P' ||
                    codeItem.trim().substring(0, 1).toUpperCase() === 'D' ||
                    codeItem.trim().substring(0, 1).toUpperCase() === 'R' ||
                    codeItem.trim().substring(0, 1).toUpperCase() === 'S'
                ) {
                    isDiscountPrice = true;
                }
            });
        return isDiscountPrice;
    };

    showPriceTypeLabel = (onlinePrice, displayOnlinePrice, skuPricesObj) => {
        let priceLabel = '';
        if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
            if (skuPricesObj.priceType === 'discount') {
                priceLabel = 'order_discount_price';
            } else if (skuPricesObj.priceType === 'wop') {
                priceLabel = 'order_global_price';
            } else if (skuPricesObj.priceType === 'yourPrice') {
                priceLabel = 'order_preferential_price';
            }
        } else {
            if (onlinePrice && displayOnlinePrice) {
                priceLabel = 'order_global_price';
            } else {
                priceLabel = 'order_preferential_price';
            }
        }
        return priceLabel;
    };

    showLastPrice = (
        displayOnlinePrice,
        skuPricesObj,
        updatedInfo,
        productInfo,
    ) => {
        let lastPrice = 0;
        if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
            lastPrice = skuPricesObj.finalPrice;
        } else {
            if (!displayOnlinePrice) {
                if (updatedInfo) {
                    lastPrice = updatedInfo.finalPrice;
                } else {
                    lastPrice = productInfo.efPrice || productInfo.finalPrice;
                }
            } else {
                lastPrice = productInfo.onlinePrice || productInfo.finalPrice;
            }
        }
        return lastPrice;
    };

    render() {
        const {
            productInfo,
            isProduct,
            isShoppingCart,
            cartInfo,
            updatedInfo,
            displayOnlinePrice,
            isDemoSite,
            skuPricesObj,
            quoteInfor,
        } = this.props;

        const {
            dialogOpened,
            num,
            checked,
            customerInfoOpened,
            quoteDetailsOpened,
            isQuoteInfor,
        } = this.state;
        const createMarkup = (text) => ({__html: text});
        let lang = loadLanguage();
        return (
            <Card
                className={
                    !productInfo.available && isShoppingCart
                        ? 'change-shipment-card disabled'
                        : 'change-shipment-card'
                }>
                <div
                    className={
                        isShoppingCart
                            ? 'card-content adjust-width'
                            : 'card-content'
                    }>
                    <Grid className="top-content" container spacing={0}>
                        <Grid className="left-content-grid" item xs={4}>
                            <div className="image-box">
                                <ChangeShipmentImage
                                    src={productInfo.productPic}
                                    alt={productInfo.productName}
                                />
                            </div>
                        </Grid>

                        <Grid className="right-content-grid" item xs={8}>
                            <Grid
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid className="product-title" item xs={12}>
                                    <div
                                        className="checkbox-text"
                                        dangerouslySetInnerHTML={createMarkup(
                                            productInfo.productName,
                                        )}
                                    />
                                    {isProduct ? (
                                        <span
                                            className="product-title-btn"
                                            testid="change-shipment-card-sku-value"
                                            onClick={() =>
                                                this.openDetails(
                                                    productInfo.sku,
                                                )
                                            }>
                                            {T('moreDetails')}
                                        </span>
                                    ) : null}
                                </Grid>
                            </Grid>

                            {lang !== 'EN' ? (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={7}>
                                        <span>{T('sku')}:</span>
                                        <span testid="change-shipment-card-sku">
                                            {productInfo.sku}
                                        </span>
                                    </Grid>
                                    {productInfo.type !== 2 ? (
                                        <Grid item xs={5}>
                                            <span>{T('inventory')}:</span>
                                            <span>
                                                {productInfo.inventory > 0
                                                    ? productInfo.inventory
                                                    : 0}
                                            </span>
                                        </Grid>
                                    ) : productInfo.tfsInventory ||
                                      productInfo.tfsInventory === 0 ? (
                                        <Grid item xs={5}>
                                            <span>{T('inventory')}:</span>

                                            <span testid="tm-website-inventory-status">
                                                {productInfo.tfsInventory === 0
                                                    ? T('stockout')
                                                    : productInfo.tfsInventory >
                                                          0 &&
                                                      productInfo.tfsInventory <=
                                                          10
                                                    ? T('short_of_stock')
                                                    : productInfo.tfsInventory >
                                                      10
                                                    ? T('in_stock')
                                                    : null}
                                            </span>
                                        </Grid>
                                    ) : null}
                                </Grid>
                            ) : (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('sku')}:</span>
                                        <span>{productInfo.sku}</span>
                                    </Grid>
                                    {productInfo.type !== 2 ? (
                                        <Grid item xs={12}>
                                            <span>{T('inventory')}:</span>
                                            <span>
                                                {productInfo.inventory > 0
                                                    ? productInfo.inventory
                                                    : 0}
                                            </span>
                                        </Grid>
                                    ) : productInfo.tfsInventory ||
                                      productInfo.tfsInventory === 0 ? (
                                        <Grid item xs={12}>
                                            <span>{T('inventory')}:</span>

                                            <span testid="tm-website-inventory-status">
                                                {productInfo.tfsInventory === 0
                                                    ? T('stockout')
                                                    : productInfo.tfsInventory >
                                                          0 &&
                                                      productInfo.tfsInventory <=
                                                          10
                                                    ? T('short_of_stock')
                                                    : productInfo.tfsInventory >
                                                      10
                                                    ? T('in_stock')
                                                    : null}
                                            </span>
                                        </Grid>
                                    ) : null}
                                </Grid>
                            )}

                            {productInfo.isOnSale ? (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={7}>
                                        <span>{T('specifications')}:</span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: productInfo.specifications,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('specifications')}:</span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: productInfo.specifications,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {productInfo.type === 1 && productInfo.eta && (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('product_eta')}:</span>
                                        <span>{productInfo.eta}</span>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>

                    {isShoppingCart && productInfo.available ? (
                        <Grid className="bottom-content" container spacing={0}>
                            <Grid className="list-price-grid" item xs={7}>
                                <Grid container spacing={0}>
                                    <Grid className="list-price" item xs={12}>
                                        <i className="rmb"></i>{' '}
                                        <span className="price-font">
                                            {util.toMoney(
                                                this.showLastPrice(
                                                    displayOnlinePrice,
                                                    skuPricesObj,
                                                    updatedInfo,
                                                    productInfo,
                                                ),
                                            )}
                                        </span>
                                        <span className="price-label">
                                            {T(
                                                this.showPriceTypeLabel(
                                                    productInfo.onlinePrice,
                                                    displayOnlinePrice,
                                                    skuPricesObj,
                                                ),
                                            )}
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid className="counter-shopping-cart" item xs={5}>
                                <ChangeSwitch
                                    title="changeSkuType"
                                    scLabel={T('SupplyCenterType')}
                                    tfsLabel={T('TfsType')}
                                    defaultValue={
                                        productInfo.type === 1
                                            ? ''
                                            : productInfo.type
                                    }
                                    changeSku={productInfo.sku}
                                    cartId={cartInfo.id}
                                    inventory={
                                        productInfo.type === 1
                                            ? productInfo.inventory
                                            : productInfo.tfsInventory
                                    }
                                    onChange={this.handleChange}></ChangeSwitch>
                            </Grid>
                        </Grid>
                    ) : null}

                    {this.props.children}
                </div>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeDetails}
                    opened={dialogOpened}
                    options={{bgClickClose: true}}>
                    <div className="product-popup">
                        <Grid
                            className="product-title-container"
                            container
                            spacing={0}>
                            <Grid className="product-title-grid" item xs={12}>
                                <span>{T('productDetails')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="product-details-container"
                            container
                            spacing={0}>
                            <Grid className="product-name-grid" item xs={12}>
                                {/*<span>{productInfo.productName}</span>*/}
                                <div
                                    className="checkbox-text"
                                    dangerouslySetInnerHTML={createMarkup(
                                        productInfo.productName,
                                    )}
                                />
                            </Grid>
                            <Grid
                                className="product-description-grid"
                                item
                                xs={12}>
                                {/*<span>{productInfo.description}</span>*/}
                                <div
                                    className="checkbox-text"
                                    dangerouslySetInnerHTML={createMarkup(
                                        productInfo.description,
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            className="confirm-button-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    onClickOfSingleTap={this.closeDetails}>
                                    <span>{T('getInfo')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeCustomerInfo}
                    opened={customerInfoOpened}
                    options={{bgClickClose: true}}>
                    <div className="customer-info-popup">
                        <Grid
                            className="customer-info-container"
                            container
                            spacing={0}>
                            <Grid
                                className="customer-info-title-grid"
                                item
                                xs={12}>
                                <span>{T('order_contact_service')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={3}>
                                <span>{T('order_phone_colon')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={9}>
                                <span>{T('order_service_mobile')}</span>
                            </Grid>

                            <Grid item xs={3}></Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={9}>
                                <span>{T('order_service_phone')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-email-grid"
                                item
                                xs={3}>
                                <span>{T('order_service_mail')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-email-grid"
                                item
                                xs={9}>
                                <span>{T('order_business_consult_email')}</span>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeQuoteDetails}
                    opened={quoteDetailsOpened && isQuoteInfor}
                    options={{bgClickClose: true}}>
                    <div className="quote-popup">
                        <Grid
                            className="quote-title-container"
                            container
                            spacing={0}>
                            <Grid className="quote-title-grid" item xs={12}>
                                <span>{T('porduct_quote_details')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="quote-details-container"
                            container
                            spacing={0}>
                            <Grid className="quote-name-grid" item xs={12}>
                                <div className="checkbox-text">
                                    <span className="checkbox-sku">
                                        {productInfo.sku}
                                    </span>
                                    <span>{productInfo.productName}</span>
                                </div>
                            </Grid>
                            {/* <Grid
                                className="quote-description-grid"
                                item
                                xs={12}>
                                {quoteInfor &&
                                    quoteInfor.map((item, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className="quote-description-box">
                                                <div className="quote-infor-left">
                                                    <div className="quote-infor describe-text">
                                                        {
                                                            item.quoteInfo
                                                                .description
                                                        }
                                                    </div>
                                                    <div
                                                        className={util.getClassName(
                                                            {
                                                                'quote-infor':
                                                                    true &&
                                                                    lang !==
                                                                        'EN',
                                                                'en-quote-infor':
                                                                    true &&
                                                                    lang ===
                                                                        'EN',
                                                            },
                                                        )}>
                                                        <span className="infor-text">
                                                            {item.discountPercent
                                                                ? T(
                                                                      'porduct_discount',
                                                                  ) +
                                                                  item.discountPercent +
                                                                  '%'
                                                                : item.discountFixedPrice
                                                                ? T(
                                                                      'porduct_quote_price',
                                                                  ) +
                                                                  item.discountFixedPrice
                                                                : null}{' '}
                                                            &nbsp;
                                                        </span>
                                                        <span className="infor-text">
                                                            {T(
                                                                'porduct_min_quantity',
                                                            ) + item.quantity}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="quote-infor-right">
                                                    <div className="quote-code">
                                                        {item.quoteInfo.number}
                                                    </div>
                                                    <BasicButton
                                                        type="primary"
                                                        className="quote-copy"
                                                        onClickOfSingleTap={() =>
                                                            this.copyContent(
                                                                item.quoteInfo
                                                                    .number,
                                                            )
                                                        }
                                                        isStopPropagation={
                                                            true
                                                        }>
                                                        {T('copy')}
                                                    </BasicButton>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </Grid> */}
                        </Grid>

                        <Grid
                            className="confirm-button-container"
                            container
                            spacing={0}>
                            {isProduct ? (
                                <Grid
                                    className="confirm-button-grid"
                                    item
                                    xs={12}>
                                    <div
                                        className="notice-text"
                                        dangerouslySetInnerHTML={createMarkup(
                                            T('porduct_shopping_cart_used'),
                                        )}
                                    />
                                </Grid>
                            ) : null}
                            <Grid
                                className={
                                    isProduct
                                        ? 'confirm-button-grid'
                                        : 'confirm-button-grid grid-top'
                                }
                                item
                                xs={12}>
                                <BasicButton
                                    disabled={false}
                                    onClickOfSingleTap={this.closeQuoteDetails}>
                                    <span>{T('getInfo')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </Card>
        );
    }
}

export default ChangeShipmentCard;
